<template>
  <nav class="navigation white--text">
    <div class="container py-0">
      <ul class="navigation__list row">
        <li class="navigation__item navigation__item-container col-auto pr-6">
          <img src="@/assets/images/pre-logo.svg" alt="" />
        </li>
        <li
          v-if="accessFor(['ROLE_ADMIN', 'ROLE_DEALER'])"
          class="navigation__item navigation__item-container col-auto px-6"
        >
          <router-link
            v-if="!requestUrl"
            :to="{
              name: 'accountOverview',
              query: $store.state.settings.filters.accountOverview,
            }"
          >
            Moje požadavky
          </router-link>

          <a
            class="router-link-active"
            @click.prevent="reload"
            href="#"
            v-else
          >
            Moje požadavky
          </a>
        </li>
        <li
          v-if="accessFor(['ROLE_ADMIN', 'ROLE_DEALER'])"
          class="navigation__item navigation__item-container col-auto px-6"
        >
          <router-link
            :to="{
              name: 'arrange',
            }"
          >
            Potřebuji zařídit
          </router-link>
        </li>
        <li class="navigation__item col-12 col-sm-6 col-md-4 ml-auto py-0">
          <div v-if="accessToken" class="navigation__item-container login col px-2">
            <v-row class="no-gutters">
              <v-col cols="12" class="text-truncate">
                <v-icon color="white" class="mt-n1 mr-1">mdi-account-outline</v-icon>
                <router-link
                  class="navigation__userlink"
                  :to="{
                    name: 'myProfile',
                  }"
                >
                  {{ userName }}
                </router-link>
              </v-col>
              <v-col cols="auto" class="d-flex align-center logout-line">
                <div class="company-value">
                  {{ reduceTextLength(organizationName).text }}
                </div>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="align-center logout-line">
                <span class="px-2">|</span>
                <a href="#" @click.prevent="logout">Odhlásit</a>
              </v-col>
            </v-row>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'TheNavigation',
  computed: {
    ...mapState({
      accessToken: (state) => state.auth.accessToken,
      userName: (state) => (state.auth.user ? state.auth.user.user_name : ''),
      organizationName: (state) => (state.auth.user && state.auth.user.principal ? state.auth.user.principal.organizationName : ''),
    }),
    requestUrl() {
      return window.location.pathname.includes(this.$route.path) && this.$route.name === 'accountOverview';
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
    logout() {
      this.$store.dispatch('auth/logout');
    },
    reduceTextLength(text) {
      if (text && text.length > 30) {
        return {
          text: `${text.substring(0, 30)} ...`,
          reduced: true,
        };
      }
      return {
        text,
        reduced: false,
      };
    },
  },
};
</script>

<style lang="scss">
@import '../scss/utilities/px-to-rem';

.v-application {
  .navigation {
    background: #1c2f67;
    margin-bottom: 25px;
  }

  .navigation__list {
    padding: 0;
    list-style: none;
    .login .logout-line {
      position: relative;
      bottom: -10px;
    }

    .login a {
      @include rem(font-size, 14px);
      font-weight: 300;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
        color: #fff;
      }

      &.navigation__userlink {
        text-decoration: none;
        font-size: 1.0rem;
        font-weight: 500;
      }
    }

    .company-value {
      @include rem(font-size, 14px);
      font-weight: 300;
    }
  }

  .navigation__item {
    position: relative;
    align-items: center;
    display: flex;
  }

  .navigation__item-container {
    padding-top: 11.5px;
    padding-bottom: 11.5px;
  }

  .navigation__item a {
    @include rem(font-size, 20px);
    color: #fff;
    text-decoration: none;

    &:hover {
      color: #95b5d8;
    }
  }

  .navigation__item .router-link-active {
    color: #95b5d8;

    &::before {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 8px 10px 0 10px;
      border-color: #1c2f67 transparent transparent transparent;
    }

    &.navigation__userlink {
      color: #fff;

      &::before {
        border-color: #6aa823 transparent transparent transparent;
      }

      &:hover {
        opacity: 1;
      }
    }
  }
}

.login {
  background: #6aa823;
  height: 100%;
  padding-bottom: 7px;
}
</style>
